import { IListViewField } from "src/components/Shared/ILIstViewField";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { AppEntities } from "src/config/entities";


const PostingOfGoodsList = () => {
  const fields: IListViewField[] = [
    {
      fieldName: "companyName",
      title: "Company",
      fieldType: "string"
    },
    {
    fieldName: "warehouseName",
      title: "Warehouse",
      fieldType: "string"
    }
  ];

  return (
    <>
      <ListView
        fields={fields}
        entity={AppEntities.PostingOfGoods}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>{" "}
    </>
  );
};

export default PostingOfGoodsList;
